import React from 'react' ;
import { Icons } from 'tc-minibox';
import { icons_config } from '../../../config/context.config';
import { AnimatePresence, motion } from 'framer-motion';

export interface ListElement {
    id : string |  number,
    name : string | number,
    text : string, 
}

export interface DropDownProps {
    reference : string,
    hover : any, 
    setHover : React.Dispatch<React.SetStateAction<any>>,
    value : any, 
    setValue : React.Dispatch<React.SetStateAction<any>>,
    list : ListElement[], 
}

export default function DropDown(props:DropDownProps) {
    /*
        PROPS : 
            - reference
            - hover, 
            - setHover, 
            - data, 
            - setData, 
            - list => (keys = ['id', 'name', 'text'])
    */
    return (
        <div 
            className='dropdown'
            onMouseEnter={() => { props.setHover(props.reference)}}
            onMouseLeave={() => { props.setHover(null)}}
    >
        <p>
            {props.list.find((el) => el.name === props.value)?.text}
        </p>
        <div 
            style = {{transform : `rotate(${props.hover === props.reference ? "180deg" : "0"})`}}
            className='tc-icons'
        >
            <Icons name = "chevron-up" {...icons_config}/>
        </div>

        {
            props.hover === props.reference ? 
                <div 
                    //transition = {{duration : 0.1}}
                    className='dropdown--list'
                >   
                    {
                        props.list.filter(el => el.name !== props.value).map((el, position)=> (
                                <div 
                                    //whileHover = {{scale : 1.1}}
                                    //whileTap = {{scale : 0.90}}
                                    onClick = {() => {
                                        props.setHover(null)
                                        props.setValue(el)
                                    }}
                                    key = {el.id}
                                >
                                    {el.text}
                                </div>
  
                        ))
                    }
                </div>
            : 
                null
        }

    </div>
    )
}